var map = {
	"./1.png": 15073,
	"./10.png": 74892,
	"./2.png": 56229,
	"./3.png": 38716,
	"./4.png": 22323,
	"./5.png": 71562,
	"./6.png": 20545,
	"./7.png": 47832,
	"./8.png": 49487,
	"./9.png": 80742
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35223;